<template>
  <div class="actions">
    <a
      href="javascript:void(0)"
      class="btn btn-primary btn-icon"
      data-toggle="modal"
      data-target="#update-pack"
      @click.prevent="setSelected"
    > 
      <i class="icofont icofont-pencil" />
    </a>
    <a
      href="javascript:void(0)"
      class="btn btn-danger btn-sm"
      @click.prevent="deleting"
    > 
      <i class="icofont icofont-close" />
    </a>
  </div>
</template>
    
    <script>
    import { mapMutations } from 'vuex';
  import { DELETE_PACK } from '../../../graphql/pack';
    export default {
        props: {object: {type: Object, required: true}},
        data(){
            return  {
    
            }
        },
        methods: {
            ...mapMutations({
                setSelectedObject: 'SET_SELECTED_OBJECT',
                setPhotos: 'market/SET_PRODUCT_PHOTOS',
                addPhoto: 'market/ADD_PRODUCT_PHOTO',
            }),
            setSelected(){
                this.setSelectedObject(this.object)
                this.setPhotos([])
                this.addPhoto(JSON.parse(this.object.photo))
            },
            deleting(){
                this.$apollo.mutate({
                    mutation: DELETE_PACK,
                    variables: {
                        "uid": this.object.uid
                    },
                    update: (data) => {
                        if(data) console.log(`Pack  ${this.object.libelle} at ${this.object.uid} deleted successfully`)
                        else console.log(`Error in deletting pack  ${this.object.libelle}`)
                    }
                  })
    
            }
        }
    }
    </script>
    
    <style>
    
    </style>